import React from "react";
import PageHeader from "../components/PageHeader";
import CtaBanner from "../components/CtaBanner";
import Contact from "../components/Contact";
import useSEO from "../lib/seo";

export default function ContactPage() {
  useSEO({
    title: "Contact LNZ Designs & Development | Kingston, Jamaica",
    description:
      "Contact LNZ Designs & Development Co. Ltd at 4½ Camp Road, Kingston, Jamaica. Call 876-521-9232, WhatsApp 876-408-1581 or email admin@thelnzgroup.com to start your project.",
    path: "/contact",
    keywords:
      "contact LNZ, LNZ Kingston Jamaica office, construction consultation Jamaica, engineering consultation, free estimate construction",
  });
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="GET IN TOUCH"
        title="Concept to completion — "
        accent="starts with a conversation."
        description="Share a few details and our engineering team will respond within one business day. Prefer a direct line? Call, email or message us on WhatsApp."
      />
      <CtaBanner />
      <Contact />
    </div>
  );
}
